<template>
  <div class="home">
    <b-container class="homeContainer">
        <!-- <b-row>
          <b-col class="colClass">
              <div class="RolexSection">
                <iframe :src="'https://wp-ocssport.ocs-sport.com/aus-js/html/golf_aus_pga_HTML_300x75/rolex.html?id=' + season + '&name=' + namecourse + '&timediff=' + timediff + '&code=' + codeRolex + '&until=' + until + '&tour=aus'" style="width:100%;height:75px;border:0;margin:0;padding:0;overflow:hidden;scroll:none" SCROLLING=NO frameborder="NO"></iframe>
              </div>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col lg='12' md='12' cols='12' class="mobileWidth">
              <div class="homeReport-list HomehomeReport-list homeHeight" :style="{height: NewWidgetHeight, 'min-height' : NewMinheight, 'max-height' : NewMaxheight }" :class="{mobWidgetPad: mobWidget == 'Y'}">
                <template v-if="showTabs">
                  <template v-if="allData != ''">
                    <b-tabs content-class="test" >
                      <template v-if="currentReport.includes('result')">
                        <b-tab title="Leaderboard" id="onetab" title-item-class="tabsStyle tabone" active >
                          <!-- <b-form-select v-model="class_api" class="textPos"  v-on:change="changeTournament(class_api)" v-if="show == true">  -->
                          <div class="TournDrop" v-if="smallListTours.length > 1 || multi_tourns == 'Y'">
                            <template v-if="multi_tourns == 'Y'">
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'"> 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :class="{showNone : allData.short_name == past.name}"
                                >
                                  {{ past.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :title="past.name"
                                  >
                                    {{past.name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                            <template v-else>
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'" > 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(value,
                                  index) in smallListTours"
                                  :key="index"
                                  :value="value.Code"
                                  :class="{showNone : allData.short_name == value.Name}"
                                >
                                  {{value.Name}}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in smallListTours"
                                  :key="index" 
                                  :value="past.Code"
                                  :title="past.Name"
                                  >
                                    {{past.Name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                          </div>
                          <template v-if="this.runData == 'Y'">
                              <!-- Change Tourn  -->
                              <ReportHomeTab
                                :data="data"
                                :Year="season"
                                :code="course"
                                :course_code="course_code"
                                :reportURL="currentReport"
                                :currentReport="reportTitle"
                                :title="currentTitle"
                                :config="config"
                                :home="home"
                                :tournDates="tournDates"
                                :updateSize="updateSize"
                                :widgetHeight="widgetHeight"
                                :reports="reports"
                                :tourCode="tourCode"
                                :show="show"
                                :runData="runData"
                                :match="'N'"
                                :listFinalAll="listFinalAll"
                                :multi_tourns="multi_tourns"
                                :smallListTours="smallListTours"
                                :nameTourn="name"
                                :sponsorLogo="sponsorLogo"
                                :roundPlayed="roundPlayed"
                                :nameWomen="nameWomen"
                                :wpgaOnly="wpgaOnly"
                                :reptour="reptour"
                                :is_qualifier="is_qualifier"
                              />
                              <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                                <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, }">
                                  <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                                </div>
                              </template>
                              <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                                <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, }">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                                </div>
                              </template>
                              <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                                <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                  <p>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </div>
                              </template>
                          </template>
                          <template v-else>
                            <!-- Orginal Tourn -->
                            <ReportHomeTab
                              :data="data"
                              :Year="season"
                              :code="course"
                              :course_code="course_code"
                              :reportURL="currentReport"
                              :currentReport="reportTitle"
                              :title="currentTitle"
                              :config="config"
                              :home="home"
                              :tournDates="tournDates"
                              :updateSize="updateSize"
                              :widgetHeight="widgetHeight"
                              :reports="reports"
                              :tourCode="tourCode"
                              :show="show"
                              :runData="runData"
                              :match="'N'"
                              :listFinalAll="listFinalAll"
                              :multi_tourns="multi_tourns"
                              :smallListTours="smallListTours"
                              :nameTourn="name"
                              :sponsorLogo="sponsorLogo"
                              :roundPlayed="roundPlayed"
                              :nameWomen="nameWomen"
                              :wpgaOnly="wpgaOnly"
                              :reptour="reptour"
                              :is_qualifier="is_qualifier"
                            />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                        </b-tab>
                      </template>
                      <template v-else>
                        <b-tab title="This Week" id="onetab" title-item-class="tabsStyle tabone" active >
                          <!-- <b-form-select v-model="class_api" class="textPos"  v-on:change="changeTournament(class_api)" v-if="show == true">  -->
                          <div class="TournDrop" v-if="smallListTours.length > 1 || multi_tourns == 'Y'" >
                            <template v-if="multi_tourns == 'Y'">
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'"> 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :class="{showNone : allData.short_name == past.name}"
                                >
                                  {{ past.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :title="past.name"
                                  >
                                    {{past.name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                            <template v-else>
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'" > 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(value,
                                  index) in smallListTours"
                                  :key="index"
                                  :value="value.Code"
                                  :class="{showNone : allData.short_name == value.Name}"
                                >
                                  {{value.Name}}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in smallListTours"
                                  :key="index" 
                                  :value="past.Code"
                                  :title="past.Name"
                                  >
                                    {{past.Name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                          </div>
                          <template v-if="this.runData == 'Y'">
                              <!-- Change Tourn  -->
                              <ReportHomeTab
                                :data="data"
                                :Year="season"
                                :code="course"
                                :course_code="course_code"
                                :reportURL="currentReport"
                                :currentReport="reportTitle"
                                :title="currentTitle"
                                :config="config"
                                :home="home"
                                :tournDates="tournDates"
                                :updateSize="updateSize"
                                :widgetHeight="widgetHeight"
                                :reports="reports"
                                :tourCode="tourCode"
                                :show="show"
                                :runData="runData"
                                :match="'N'"
                                :listFinalAll="listFinalAll"
                                :multi_tourns="multi_tourns"
                                :smallListTours="smallListTours"
                                :nameTourn="name"
                                :sponsorLogo="sponsorLogo"
                                :roundPlayed="roundPlayed"
                                :nameWomen="nameWomen"
                                :wpgaOnly="wpgaOnly"
                                :reptour="reptour"
                                :is_qualifier="is_qualifier"
                              />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <!-- Orginal Tourn added -->
                            <ReportHomeTab
                              :data="data"
                              :Year="season"
                              :code="course"
                              :course_code="course_code"
                              :reportURL="currentReport"
                              :currentReport="reportTitle"
                              :title="currentTitle"
                              :config="config"
                              :home="home"
                              :tournDates="tournDates"
                              :updateSize="updateSize"
                              :widgetHeight="widgetHeight"
                              :reports="reports"
                              :tourCode="tourCode"
                              :show="show"
                              :runData="runData"
                              :match="'N'"
                              :listFinalAll="listFinalAll"
                              :multi_tourns="multi_tourns"
                              :smallListTours="smallListTours"
                              :nameTourn="name"
                              :sponsorLogo="sponsorLogo"
                              :roundPlayed="roundPlayed"
                              :nameWomen="nameWomen"
                              :wpgaOnly="wpgaOnly"
                              :reptour="reptour"
                              :is_qualifier="is_qualifier"
                            />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                        </b-tab>
                      </template>
                      <b-tab title="Upcoming" title-item-class="tabsStyle tabtwo" classActive>
                        <UpcomingReportSelect :season="season" />
                      </b-tab>
                      <b-tab title="Results" title-item-class="tabsStyle tabthree">
                        <ResultsReportSelect :season="season"/>
                      </b-tab>
                    </b-tabs>
                  </template>
                  <template v-else>
                    <b-tabs content-class="test" >
                      <b-tab title="Upcoming" title-item-class="tabsStyle tabWidth" classActive active>
                        <UpcomingReportSelect :season="season"/>
                      </b-tab>
                      <b-tab title="Results" title-item-class="tabsStyle tabWidth">
                        <ResultsReportSelect :season="season"/>
                      </b-tab>
                    </b-tabs>
                  </template> 
                </template>
                <template v-else>
                  <template v-if="allData != ''">
                    <b-tabs content-class="test" >
                      <template v-if="currentReport.includes('result')">
                        <b-tab title="Leaderboard" id="onetab" title-item-class="tabsStyle tabone" active >
                          <!-- <b-form-select v-model="class_api" class="textPos"  v-on:change="changeTournament(class_api)" v-if="show == true">  -->
                          <div class="TournDrop" v-if="smallListTours.length > 1 || multi_tourns == 'Y'">
                            <template v-if="multi_tourns == 'Y'">
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'"> 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :class="{showNone : allData.short_name == past.name}"
                                >
                                  {{ past.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :title="past.name"
                                  >
                                    {{past.name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                            <template v-else>
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'" > 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(value,
                                  index) in smallListTours"
                                  :key="index"
                                  :value="value.Code"
                                  :class="{showNone : allData.short_name == value.Name}"
                                >
                                  {{value.Name}}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in smallListTours"
                                  :key="index" 
                                  :value="past.Code"
                                  :title="past.Name"
                                  >
                                    {{past.Name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                          </div>
                          <template v-if="this.runData == 'Y'">
                              <!-- Change Tourn  -->
                              <ReportHomeTab
                                :data="data"
                                :Year="season"
                                :code="course"
                                :course_code="course_code"
                                :reportURL="currentReport"
                                :currentReport="reportTitle"
                                :title="currentTitle"
                                :config="config"
                                :home="home"
                                :tournDates="tournDates"
                                :updateSize="updateSize"
                                :widgetHeight="widgetHeight"
                                :reports="reports"
                                :tourCode="tourCode"
                                :show="show"
                                :runData="runData"
                                :match="'N'"
                                :listFinalAll="listFinalAll"
                                :multi_tourns="multi_tourns"
                                :smallListTours="smallListTours"
                                :nameTourn="name"
                                :sponsorLogo="sponsorLogo"
                                :roundPlayed="roundPlayed"
                                :nameWomen="nameWomen"
                                :wpgaOnly="wpgaOnly"
                                :reptour="reptour"
                                :is_qualifier="is_qualifier"
                              />
                              <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                                <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, }">
                                  <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                                </div>
                              </template>
                              <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                                <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, }">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                                </div>
                              </template>
                              <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                                <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                  <p>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </div>
                              </template>
                          </template>
                          <template v-else>
                            <!-- Orginal Tourn -->
                            <ReportHomeTab
                              :data="data"
                              :Year="season"
                              :code="course"
                              :course_code="course_code"
                              :reportURL="currentReport"
                              :currentReport="reportTitle"
                              :title="currentTitle"
                              :config="config"
                              :home="home"
                              :tournDates="tournDates"
                              :updateSize="updateSize"
                              :widgetHeight="widgetHeight"
                              :reports="reports"
                              :tourCode="tourCode"
                              :show="show"
                              :runData="runData"
                              :match="'N'"
                              :listFinalAll="listFinalAll"
                              :multi_tourns="multi_tourns"
                              :smallListTours="smallListTours"
                              :nameTourn="name"
                              :sponsorLogo="sponsorLogo"
                              :roundPlayed="roundPlayed"
                              :nameWomen="nameWomen"
                              :wpgaOnly="wpgaOnly"
                              :reptour="reptour"
                              :is_qualifier="is_qualifier"
                            />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                        </b-tab>
                      </template>
                      <template v-else>
                        <b-tab title="This Week" id="onetab" title-item-class="tabsStyle tabone" active >
                          <!-- <b-form-select v-model="class_api" class="textPos"  v-on:change="changeTournament(class_api)" v-if="show == true">  -->
                          <div class="TournDrop" v-if="smallListTours.length > 1 || multi_tourns == 'Y'" >
                            <template v-if="multi_tourns == 'Y'">
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'"> 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :class="{showNone : allData.short_name == past.name}"
                                >
                                  {{ past.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in listFinalAll"
                                  :key="index" 
                                  :value="past.code"
                                  :title="past.name"
                                  >
                                    {{past.name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                            <template v-else>
                              <!-- Desktop -->
                              <b-form-select v-model="code" class="TourndropdownArea"  @change="TournamentChange(code)" v-if="mobWidget == 'N'" > 
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == true" :value="null">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option v-if="mobWidget == 'N' && showReport == false" :value="allData.code">{{allData.short_name}}</b-form-select-option>
                                <b-form-select-option 
                                  class="opt-arrow"
                                  v-for="(value,
                                  index) in smallListTours"
                                  :key="index"
                                  :value="value.Code"
                                  :class="{showNone : allData.short_name == value.Name}"
                                >
                                  {{value.Name}}
                                </b-form-select-option>
                              </b-form-select>
                              <!-- Mobile -->
                              <b-dropdown :text='tournamentName' class="mobileDropdown" v-if="mobWidget == 'Y'">
                                <b-dropdown-item
                                  v-on:click="MobileTournamentChange"
                                  class="opt-arrow"
                                  v-for="(past,
                                  index) in smallListTours"
                                  :key="index" 
                                  :value="past.Code"
                                  :title="past.Name"
                                  >
                                    {{past.Name}}
                                </b-dropdown-item>
                            </b-dropdown>
                            </template>
                          </div>
                          <template v-if="this.runData == 'Y'">
                              <!-- Change Tourn  -->
                              <ReportHomeTab
                                :data="data"
                                :Year="season"
                                :code="course"
                                :course_code="course_code"
                                :reportURL="currentReport"
                                :currentReport="reportTitle"
                                :title="currentTitle"
                                :config="config"
                                :home="home"
                                :tournDates="tournDates"
                                :updateSize="updateSize"
                                :widgetHeight="widgetHeight"
                                :reports="reports"
                                :tourCode="tourCode"
                                :show="show"
                                :runData="runData"
                                :match="'N'"
                                :listFinalAll="listFinalAll"
                                :multi_tourns="multi_tourns"
                                :smallListTours="smallListTours"
                                :nameTourn="name"
                                :sponsorLogo="sponsorLogo"
                                :roundPlayed="roundPlayed"
                                :nameWomen="nameWomen"
                                :wpgaOnly="wpgaOnly"
                                :reptour="reptour"
                                :is_qualifier="is_qualifier"
                              />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <!-- Orginal Tourn added -->
                            <ReportHomeTab
                              :data="data"
                              :Year="season"
                              :code="course"
                              :course_code="course_code"
                              :reportURL="currentReport"
                              :currentReport="reportTitle"
                              :title="currentTitle"
                              :config="config"
                              :home="home"
                              :tournDates="tournDates"
                              :updateSize="updateSize"
                              :widgetHeight="widgetHeight"
                              :reports="reports"
                              :tourCode="tourCode"
                              :show="show"
                              :runData="runData"
                              :match="'N'"
                              :listFinalAll="listFinalAll"
                              :multi_tourns="multi_tourns"
                              :smallListTours="smallListTours"
                              :nameTourn="name"
                              :sponsorLogo="sponsorLogo"
                              :roundPlayed="roundPlayed"
                              :nameWomen="nameWomen"
                              :wpgaOnly="wpgaOnly"
                              :reptour="reptour"
                              :is_qualifier="is_qualifier"
                            />
                            <template v-if="allData.play_suspended == 'Y' && allData.live_message == 'N'">
                              <div class="LiveScoreMessage" v-if="allData.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <p v-if="allData.play_suspended == 'Y'">Play Suspended</p>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'Y' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
                                <template v-if="playsus == true">
                                  <p>Play Suspended</p>
                                </template>
                                <template v-else>
                                  <p>
                                    Play Suspended<br>
                                    {{allData.live_scoring_mess}}
                                  </p>
                                </template>
                              </div>
                            </template>
                            <template v-else-if="allData.play_suspended == 'N' && allData.live_message == 'Y'">
                              <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: allData.live_message == 'Y'}">
                                <p>
                                  {{allData.live_scoring_mess}}
                                </p>
                              </div>
                            </template>
                          </template>
                        </b-tab>
                      </template>
                    </b-tabs>
                  </template>
                  <template v-else>
                    <b-tabs content-class="test" >
                      <b-tab title="Upcoming" title-item-class="tabsStyle tabWidth" classActive active>
                        <UpcomingReportSelect :season="season"/>
                      </b-tab>
                      <b-tab title="Results" title-item-class="tabsStyle tabWidth">
                        <ResultsReportSelect :season="season"/>
                      </b-tab>
                    </b-tabs>
                  </template> 
                </template>
              </div>
          </b-col>
        </b-row>
        <b-row v-if="showRolex">
          <b-col class="colClass">
            <div class="RolexSection">
              <iframe
                :src="'https://wp-ocssport.ocs-sport.com/aus-js/html/golf_aus_pga_HTML_300x75/rolex.html?id='
                  + season
                  + '&name=' + namecourse
                  + '&timediff=' + timediff
                  + '&code=' + codeRolex
                  + '&until=' + until
                  + '&tour=aus'"
                style="width:100%;height:75px;border:0;margin:0;padding:0;overflow:hidden;"
                scrolling="no"
                frameborder="0">
              </iframe>
            </div>
          </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
import ReportHomeTab from "@/components/reportHometab.vue";
import UpcomingReportSelect from "@/components/UpcomingReportSelect.vue";
import ResultsReportSelect from "@/components/ResultsReportSelect.vue";
import axios from "axios";
export default {
  name: "StarterHome", 
  props: ['config'],
  components: { 
    UpcomingReportSelect,
    ResultsReportSelect,
    ReportHomeTab,
  }, // Everything below on every /view/<Page Name>.vue for meta info and all ACF data
  data: function() {
    return {
      title: [], //Page Title
      description: [], //Meta Description
      homepage: true,
      home: true,
      wphome: [],
      inter: "5",
      pro: "44",
      latestsm: "29",
      latestFull: "8",
      featHome: "true",
      data: [],
      reports: [],
      course: [],
      season: [],
      course_code: [],
      tm_params:[],
      mobWidget: process.env.VUE_APP_MOB_WIDGET,
      // tourCode: '',
      tourCode: [],
      NextTournCode: [],
      text: '',
      NewWidgetHeight: '',
      NewMinheight: '',
      NewMaxheight: '',
      activeTab: '',
      scores_available: '',
      showReports: '',
      results_available: '',
      smallListTours: [],
      FullListT: [],
      show: false,
      runData: 'N',
      url: '',
      multi_tourns: '',
      finalFilter: [],
      firstArray: [],
      listFinalAll:[],
      EveryTour: [],
      switch: false,
      code: null,
      playsus: false,
      name: '',
      namecourse: '',
      timediff: '',
      until: '',
      codeRolex: '',
      updateSize: '',
      widgetHeight: '',
      upComingAus: [],
      upComingWPG: [],
      sponsorLogo: '',
      roundPlayed: '',
      nameWomen:'',
      showReport: true,
      tournamentName: '',
      reptour: '',
      wpgareports: [],
      FirstCoursecode: '', 
      courseCodeWPGA: '',
      wpgaDaysAway: '',
      wpgaOnly: 'N',
      ts_final_result: '',
      allData: [],
      combinedTours: [],
      WpgData: [],
      AusData: [],
      allAusTours: [],
      allWpgaTours: [],
      FirstCoursecodewpg: '',
      reportswpg: [],
      daysAwaywpg: '',
      tournDateswpg: '',
      tournamentNamewpg: '',
      FirstCoursecodeaus: '',
      reportsaus: [],
      daysAwayaus: '',
      tournDatesaus: '',
      tournamentNameaus: '',
      class_apiaus: '',
      class_apiwpg: '',
      wpgaCon: [],
      ausCon: [],
      is_qualifier: '',
      is_qualifierwpg:'',
      is_qualifieraus: ''
    };
  },
  methods: {
    updateStuffMulti: function() {
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          return axios.get(
            process.env.VUE_APP_TIC_BASE +
            'aus/' +
              this.season +
              "/" +
              this.season +
              "-" +
              this.allData.code +
              "-tmticx.json?randomaddUPDATE=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.tm_params = response.data;
        });
    },
    updateStuffMultiTour: function(code) {
      this.wpgCode = code
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          return axios.get(
            process.env.VUE_APP_TIC_BASE +
            'wpg/' +
              this.season +
              "/" +
              this.season +
              "-" +
              this.wpgCode +
              "-tmticx.json?randomadd=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.tm_params = response.data;
          
        });
    },
    MobileswapTour: function(event) {
      var title = event.target.getAttribute("title");
      console.log("title " + title)
      var code = event.target.getAttribute("value");
      console.log("code " + code)
      this.tournamentName = title;
      console.log("this.tournamentName " + this.tournamentName)
      this.course = code;
      console.log("this.course " + this.course)
      this.updateStuffMulti(code);
      this.getSecondTournTicx(code);
    },
    swapTour:function(code) {
      if (this.allData.code == code) {
        console.log('TRUE Y')
        this.showReport = true;
      } else {
        console.log('FALSE N')
        this.showReport = false;
      }
      this.course = code;
      // Aus Code
      // this.updateStuffMulti(code);
      // this.getSecondTournTicx(code);
      // Wpga
        this.updateStuffMultiTour(code);
        this.getTourSecondTick(code); 

    },
    getSecondTournTicx(code) {
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          console.log("this.data")
          console.log(this.data)
          return axios.get(
            process.env.VUE_APP_TIC_BASE + 
              'aus/' +
              this.season +
              "/" +
              this.season +
              "-" +
              code +
              "-tmticx.json?mattrandomadd=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.second_tourn_tixc = response.data;
          this.reports = response.data.reports.reports_entry;
          this.tournDates = response.data.dic_dates;
          this.name = response.data.short_name
          this.namecourse = response.data.course_city;
          this.is_qualifier = response.data.is_qualifier;
          this.timediff = response.data.time_diff_dec;
          this.until = response.data.days_away;
          this.codeRolex = response.data.code;
          this.sponsorLogo = response.data.sponsor_logo;
          this.roundPlayed = response.data.rounds_played;
          this.winnerType = response.data.winner_result;
          if (typeof this.second_tourn_tixc.reports != "undefined") {
            console.log('in second tmticx')
            if (Array.isArray(this.reports)) {
              this.second_tourn_tixc.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                  this.report = element.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmdraw") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
              });
            } else {
                if (this.reports.report_url.indexOf("tmentry") !== -1) {
                  this.report = this.reports.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
            }

          }
        });
    },
    getTourSecondTick(code) {
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          return axios.get(
            process.env.VUE_APP_TIC_BASE + 
              'wpg/' +
              this.season +
              "/" +
              this.season +
              "-" +
              code +
              "-tmticx.json?mattrandomadd=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.second_tourn_tixc = response.data;
          this.reports = response.data.reports.reports_entry;
          this.tournDates = response.data.dic_dates;
          this.namecourse = response.data.course_city;
          this.is_qualifier = response.data.is_qualifier;
          this.timediff = response.data.time_diff_dec;
          this.until = response.data.days_away;
          this.codeRolex = response.data.code;
          // this.nameWomen = response.data.short_name
          this.name = response.data.short_name
          this.sponsorLogo = response.data.sponsor_logo;
          this.roundPlayed = response.data.rounds_played;
          this.winnerType = response.data.winner_result;
          if (typeof this.second_tourn_tixc.reports != "undefined") {
            if (Array.isArray(this.reports)) {
              this.second_tourn_tixc.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMultiTour(code);
                }
                if (element.report_url.indexOf("tmdraw") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMultiTour(code);
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMultiTour(code);
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMultiTour(code);
                }
              });
            } else {
              if (this.reports.report_url.indexOf("tmentry") !== -1) {
                this.report = this.reports.report_url;
                this.updateStuffMultiTour(code);
              }
            }

          }
        });
    },
    MobileTournamentChange: function(event) {
      var title = event.target.getAttribute("title");
      console.log("title " + title)
      var code = event.target.getAttribute("value");
      console.log("code " + code)
      this.tournamentName = title;
      console.log("this.tournamentName " + this.tournamentName)
      this.course = code;
      console.log("this.course")
      console.log(this.course)
      let codeTourn = [];
      console.log("codeTourn")
      console.log(codeTourn)
      this.tourCode = codeTourn;
      this.NextTournCode = codeTourn;
      this.smallListTours.forEach((value) => {
          if (value.Code == this.course) {
            codeTourn.push(value.class_api);
          }
      }); 
      if (codeTourn[0] == 'aus') {
        this.getSecondTournTicx(code);
        this.updateStuffMulti(code);
      } else if(codeTourn[0] == 'wpg') {
        this.updateStuffMultiTour(code);
        this.getTourSecondTick(code); 
      } else {
        this.getSecondTournTicx(code);
        this.updateStuffMulti(code);
      }
    },
    TournamentChange: function(code) {
      if (this.allData.code == code) {
        console.log('TRUE Y')
        this.showReport = true;
      } else {
        console.log('FALSE N')
        this.showReport = false;
      }
      // this.showReport = true;
      this.course = code;
      console.log("this.course")
      console.log(this.course)
      let codeTourn = [];
      console.log("codeTourn")
      console.log(codeTourn)
      this.tourCode = codeTourn;
      this.NextTournCode = codeTourn;
      this.smallListTours.forEach((value) => {
          if (value.Code == this.course) {
            codeTourn.push(value.class_api);
          }
      }); 
      if (codeTourn[0] == 'aus') {
        this.getSecondTournTicx(code);
        this.updateStuffMulti(code);
      } else if(codeTourn[0] == 'wpg') {
        this.updateStuffMultiTour(code);
        this.getTourSecondTick(code); 
      } else {
        this.getSecondTournTicx(code);
        this.updateStuffMulti(code);
      }
    },

    reportListText: function() {
      if (Array.isArray(this.reports)) {
        this.activeTab = false
        this.classActive = 'active'
      } else {
        this.reports.forEach((value) => {
          if (value.report_title.includes('Score')) {
            this.activeTab = true
            this.classActive = 'active'
          } else {
            this.activeTab = false
            this.classActive = ''
          }
        });
      } 
    },
    // isMobile() {
    //   if (screen.width <= 768) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    myFunction: function() {
      let h = window.outerWidth;
      let txt = h;
      this.text = txt;
      if (this.text == 1400 || this.text > 1401) {
        // this.NewWidgetHeight = '669px!important'
        if (this.mobWidget == 'Y') {
          this.NewWidgetHeight = '300px!important' 
        } else {
          // if (this.multi_tourns == 'Y') {
          //   this.NewWidgetHeight = '570px!important'   
          //   this.NewMinheight = '570px!important'     
          //   this.NewMaxheight = '570px!important'            
          // } else {
          //   this.NewWidgetHeight = '589px!important'     
          //   this.NewMinheight = '589px!important'     
          //   this.NewMaxheight = '589px!important'                      
          // }
            this.NewWidgetHeight = '589px!important'     
            this.NewMinheight = '589px!important'     
            this.NewMaxheight = '589px!important'    
        }
      } else if(this.text == 1400 || this.text == 1397) {
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important'  
      } else if(this.text < 1400  && this.text > 1200) {
        // this.NewWidgetHeight = '555px!important'
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important'  
      } else if(this.text < 1199) {
         if (this.mobWidget == 'Y') {
          // this.NewWidgetHeight = '399px!important' 
          this.NewWidgetHeight = '399px!important' 
        } else {
          this.NewWidgetHeight = '411px!important'
          this.NewMinheight = '411px!important'     
          this.NewMaxheight = '411px!important'  
          this.playsus = true
        }
      } else if(this.text < 1400  && this.text > 1199) {
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important' 
      }
    },
    getAllTourns: function() {
      console.log('In')
      const aus = this.AusData;
      const wpg = this.WpgData;
      const children = aus.concat(wpg);
      console.log("children")
      console.log(children)
      let smallListTours = [];
      this.EveryTour.forEach((value) => {
        if (value.days_away < 5 && value.ts_final_result == 'N') {
          if (!value.code) {
            console.log('In foreach 658')
            smallListTours.push(value); 
          }
        }
      }); 
      smallListTours.sort((a, b) => {
          let da = a.days_away,
              db = b.days_away;
          return da - db; 
      });

      console.log(smallListTours);
      this.smallListTours = smallListTours;
      if (this.smallListTours.length > 1) {
        this.show = true
      } else {
        this.show = false
      }
      // console.log("this.smallListTours")
      // console.log(this.smallListTours)

      // Filter Section to ssee if days away match

      //Order index 0 postion
      if (smallListTours[0].class_api == 'aus') {
        this.tourCode = 'aus';
        this.gettmticXData(this.tourCode)
      } else if (smallListTours[0].class_api == 'wpg')  {
        this.tourCode = 'wpg';
        this.gettmticXData(this.tourCode)
      } else {
        this.tourCode = 'aus';
        this.gettmticXData(this.tourCode)
      }
 
    },
    getToursMulti() {
      console.log('in get tours');

      const allChildren = [...this.allAusTours, ...this.allWpgaTours]
        .filter(item => item && item.DaysAway !== undefined);

      console.log("allChildren", allChildren);
      console.log(allChildren.map(x => typeof x));
      const smallListTours = allChildren;

      this.smallListTours = smallListTours;

      this.show = smallListTours.length > 1;

      console.log("smallListTours", smallListTours);
      console.log("show:", this.show);
    },
    gettmticXData: function() {
      axios 
      .get('https://api.aus.ocs-software.com/pgaaus/cache/' + this.tourCode + '/tmticx?randomadd=' + new Date().getTime())
      .then(({ data }) => {
        this.tm_params = data;
        this.season = data.tm_params.season_code;
        this.course = data.code;
        this.multi_tourns = data.multi_tourns;
        this.is_qualifier = data.is_qualifier;
        this.course_code = data.course_code;
        this.tournDates = data.dic_dates;
        this.name = data.short_name
        this.sponsorLogo = data.sponsor_logo;
        this.roundPlayed = data.rounds_played;
        this.scores_available = data.scores_available;
        this.ts_round_status_1 = data.ts_round_status_1;
        this.daysAway = parseInt(data.days_away);
        this.firstArray = [
          {
            'name': this.name,
            'code': this.course,
          }
        ]
        this.pastTourns = data.past_tourns;
        this.futureTourns = data.future_tourns;
        if (this.pastTourns != '') {
          if (Array.isArray(data.past_tourns.past_tourns_entry)) {
            console.log("isArray");
            this.past_tourns = data.past_tourns.past_tourns_entry;
          } else {
            console.log("is not Array");
            this.past_tourns = [data.past_tourns.past_tourns_entry];
          }
          var listFinal =  this.firstArray.concat(this.past_tourns);
          this.listFinalAll = listFinal;          
        } else if (this.futureTourns !== '') {
          if (Array.isArray(data.future_tourns.future_tourns_entry)) {
            console.log("isArray");
            this.past_tourns = data.future_tourns.future_tourns_entry;
          } else {
            console.log("is not Array");
            this.past_tourns = [data.future_tourns.future_tourns_entry];
          }
          var listFinals=  this.firstArray.concat(this.past_tourns);
          this.listFinalAll = listFinals;
        }

        // if (this.daysAway > 5 || this.results_available != '' || this.ts_round_status_1 != 'S') {
        // if (this.daysAway > 5 && this.results_available != '' && this.ts_round_status_1 != 'S' || this.ts_round_status_1 != 'C') {
        if (this.daysAway > 5) {
          this.showReports = 'N'
        } else {
          this.showReports = 'Y'
        }
        this.reports = data.reports.reports_entry;
        this.reportsStart = data.reports;
        if (this.reportsStart != '') {
          let arr = [];
          this.results_available = arr;
          if (Array.isArray(this.reports)) {
            this.reports.forEach((value) => {
                if (value.report_title.includes('Result')) {
                  arr.push(value.report_title);
                  // console.log(value); 
                }
            });  
          }
        }
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
    },
    getAusSecondTournTicx() {
      console.log('In Aus')
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          console.log("this.data")
          console.log(this.data)
          return axios.get(
            process.env.VUE_APP_TIC_BASE + 
              'aus/' +
              this.tm_params.tm_params.season_code +
              "/" +
              this.tm_params.tm_params.season_code +
              "-" +
              this.courseCodeWPGA +
              "-tmticx.json?mattrandomadd=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.reptour = 'aus';
          this.second_tourn_tixc = response.data;
          this.reports = response.data.reports.reports_entry;
          this.tournDates = response.data.dic_dates;
          this.name = response.data.short_name;
          this.course = response.data.code;
          this.code = response.data.code;
          this.is_qualifier = response.data.is_qualifier;
          var code = this.code;
          console.log("code")
          console.log(code)
          this.sponsorLogo = response.data.sponsor_logo;
          this.roundPlayed = response.data.rounds_played;
          this.winnerType = response.data.winner_result;
          if (typeof this.second_tourn_tixc.reports != "undefined") {
            console.log('in second tmticx')
            if (Array.isArray(this.reports)) {
              this.second_tourn_tixc.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                  this.report = element.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmdraw") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
              });
            } else {
                if (this.reports.report_url.indexOf("tmentry") !== -1) {
                  this.report = this.reports.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
            }

          }
        });
    },
    getWPGASecondTournTicx() {
      console.log('In WPGA')
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          console.log("this.data")
          console.log(this.data)
          return axios.get(
            process.env.VUE_APP_TIC_BASE + 
              'wpga/' +
              this.tm_params.tm_params.season_code +
              "/" +
              this.tm_params.tm_params.season_code +
              "-" +
              this.FirstCoursecode +
              "-tmticx.json?mattrandomadd=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.reptour = 'wpga';
          this.second_tourn_tixc = response.data;
          this.reports = response.data.reports.reports_entry;
          this.tournDates = response.data.dic_dates;
          this.is_qualifier = response.data.is_qualifier;
          this.namecourse = response.data.course_city;
          this.timediff = response.data.time_diff_dec;
          this.until = response.data.days_away;
          this.codeRolex = response.data.code;
          this.name = response.data.short_name;
          this.course = response.data.code;
          this.code = response.data.code;
          var code = this.code;
          console.log("code")
          console.log(code)
          this.sponsorLogo = response.data.sponsor_logo;
          this.roundPlayed = response.data.rounds_played;
          this.winnerType = response.data.winner_result;
          if (typeof this.second_tourn_tixc.reports != "undefined") {
            console.log('in second tmticx')
            if (Array.isArray(this.reports)) {
              this.second_tourn_tixc.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                  this.report = element.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmdraw") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.report = element.report_url;
                  this.updateStuffMulti(code);
                }
              });
            } else {
                if (this.reports.report_url.indexOf("tmentry") !== -1) {
                  this.report = this.reports.report_url;
                  console.log("this.report --")
                  console.log(this.report)
                  this.updateStuffMulti(code);
                }
            }

          }
        });
    },
    changeTournament: function(class_api) {
      this.tourCode = class_api;
      // console.log("this.tourCode")
      // console.log(this.tourCode)
      console.log('Change')
      this.runData = 'Y'
      console.log("this.runData -- Homepage")
      console.log(this.runData)
      axios 
      .get('https://api.aus.ocs-software.com/pgaaus/cache/' + this.tourCode + '/tmticx?randomadd=' + new Date().getTime())
      .then(({ data }) => {
        this.tm_params = data;
        this.season = data.tm_params.season_code;
        this.course = data.code;
        console.log("this.course")
        console.log(this.course)
        this.course_code = data.course_code;
        this.tournDates = data.dic_dates;
        this.is_qualifier = data.is_qualifier;
        this.name = data.short_name
        this.sponsorLogo = data.sponsor_logo;
        this.roundPlayed = data.rounds_played;
        this.scores_available = data.scores_available;
        this.ts_round_status_1 = data.ts_round_status_1;
        this.daysAway = parseInt(data.days_away);
        this.updateStuff()
        // if (this.daysAway > 5 || this.results_available != '' || this.ts_round_status_1 != 'S') {
        // if (this.daysAway > 5 && this.results_available != '') {
        if (this.daysAway > 5) {
          this.showReports = 'N'
        } else {
          this.showReports = 'Y'
        }
        this.reports = data.reports.reports_entry;
        this.reportsStart = data.reports;
        if (this.reportsStart != '') {
          let arr = [];
          this.results_available = arr;
          if (Array.isArray(this.reports)) {
            this.reports.forEach((value) => {
                if (value.report_title.includes('Result')) {
                  arr.push(value.report_title);
                  // console.log(value); 
                }
            });  
          }
        }
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
    },
    changeTournamentMulti: function(code) {
      this.tourCode = 'aus';
      this.course = code
      console.log('Change')
      this.runData = 'Y'
      console.log("this.runData -- Homepage")
      console.log(this.runData)
      axios 
      .get('https://api.aus.ocs-software.com/pgaaus/cache/' + this.tourCode + '/tmticx?randomadd=' + new Date().getTime())
      .then(({ data }) => {
        this.tm_params = data;
        this.season = data.tm_params.season_code;
        // this.course = data.code;
        console.log("this.course")
        console.log(this.course)
        this.course_code = data.course_code;
        this.is_qualifier = data.is_qualifier;
        this.tournDates = data.dic_dates;
        this.name = data.short_name
        this.sponsorLogo = data.sponsor_logo;
        this.roundPlayed = data.rounds_played;
        this.scores_available = data.scores_available;
        this.ts_round_status_1 = data.ts_round_status_1;
        this.daysAway = parseInt(data.days_away);
        this.updateStuff()
        // if (this.daysAway > 5 || this.results_available != '' || this.ts_round_status_1 != 'S') {
        // if (this.daysAway > 5 && this.results_available != '') {
        if (this.daysAway > 5) {
          this.showReports = 'N'
        } else {
          this.showReports = 'Y'
        }
        this.reports = data.reports.reports_entry;
        this.reportsStart = data.reports;
        if (this.reportsStart != '') {
          let arr = [];
          this.results_available = arr;
          if (Array.isArray(this.reports)) {
            this.reports.forEach((value) => {
                if (value.report_title.includes('Result')) {
                  arr.push(value.report_title);
                  // console.log(value); 
                }
            });  
          }
        }
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
    },
    FilterFinalTourns: function() {
      if (this.filterTournaments.length > 1) {
        this.FullListT = this.filterTournaments;
        let chars = this.FullListT;

        let uniqueChars = [];
        this.finalFilter = uniqueChars;
        console.log("this.finalFilter")
        console.log(this.finalFilter)
        chars.forEach((element) => {
            if (!uniqueChars.includes(element.code)) {
                uniqueChars.push({ name: element.short_name, code: element.code, });
            }
        });

        console.log("uniqueChars");
        console.log(uniqueChars);
        console.log('this.FullListT')
        console.log(this.FullListT)
        this.show = true;
      } else if(this.filterTournamentsOne.length > 1) {
        this.FullListT = this.filterTournamentsOne;
      } else if(this.filterTournamentsTwo.length > 1) {
        this.FullListT = this.filterTournamentsTwo;
        // this.show = true;
      } else if(this.filterTournamentsThree.length > 1) {
        this.FullListT = this.filterTournamentsThree;
      } else if(this.filterTournamentsFour.length > 1) {
        this.FullListT = this.filterTournamentsFour;
      } else {
        console.log('false')
      }
    },
    async updateStuff() {
      try {
        // First call, await for call to return
        // let first_call = await apiCall.tmParamsYear(this.season);
        // this.tm_params = first_call.data;
        // this.loading = false;
        // Second call, await for call to return

        if (this.multi_tourns == "Y") {
          let first_call = await apiCall.report(this.reportTitle);
          const ticx_url =
            this.config.VUE_APP_API +
            "aus" +
            "/cache/" +
            this.apiClass +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-tmticx.json?randomadd=" +
            new Date().getTime();
          let ticx_call = await apiCall.report(ticx_url);
          this.data = first_call.data;

          if (ticx_call && ticx_call.data.reports) {
            const reports = ticx_call.data.reports.reports_entry;
            if (!Array.isArray(reports)) {
              console.log('isNot Array')
            } else{
              reports.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                  this.report_url_for_report_page = element.report_url;
                  this.reports_title = element.report_title;
                  // this.updateStuff();
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.report_url_for_report_page = element.report_url;
                  this.reports_title = element.report_title;
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.report_url_for_report_page = element.report_url;
                  this.reports_title = element.report_title;
                  // this.updateStuff();
                }
              });
            }
          }
        } else {
          let first_call = await apiCall.report(this.reportTitle);
          this.data = first_call.data;
          this.loading = false;
        }
        this.loading = false;
      } catch (error) {
        console.log("error in await calls");
        console.log(error);
        throw error;
      }
    },
    getReports: function(currentReport) {
      console.log('in reports')
      apiCall
      .report(currentReport)
      .then(({ data }) => {
        this.data = data;
        console.log("this.data")
        console.log(this.data)
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
    },
    getWPGAtmticXData: function() {
      axios 
      .get('https://api.aus.ocs-software.com/pgaaus/cache/' + 'wpg' + '/tmticx?randomadd=' + new Date().getTime())
      .then(({ data }) => {
        this.reptour = 'wpg';
        this.tm_params = data;
        this.season = data.tm_params.season_code;
        this.namecourse = data.course_city;
        this.is_qualifier = data.is_qualifier;
        this.timediff = data.time_diff_dec;
        this.until = data.days_away;
        this.codeRolex = data.code;
        this.course = data.code;
        console.log("this.couse")
        this.multi_tourns = data.multi_tourns;
        this.courseCodeWPGA = data.code;
        // console.log("this.multi_tourns")
        this.course_code = data.course_code;
        this.tournDates = data.dic_dates;
        this.name = data.short_name
        this.sponsorLogo = data.sponsor_logo;
        this.roundPlayed = data.rounds_played;
        this.scores_available = data.scores_available;
        this.ts_round_status_1 = data.ts_round_status_1;
        this.daysAway = parseInt(data.days_away);
        this.firstArray = [
          {
            'name': this.name,
            'code': this.course,
          }
        ]
        this.pastTourns = data.past_tourns;
        this.futureTourns = data.future_tourns;
        if (this.pastTourns != '') {
          if (Array.isArray(data.past_tourns.past_tourns_entry)) {
            console.log("isArray");
            this.past_tourns = data.past_tourns.past_tourns_entry;
          } else {
            console.log("is not Array");
            this.past_tourns = [data.past_tourns.past_tourns_entry];
          }
          var listFinal =  this.firstArray.concat(this.past_tourns);
          this.listFinalAll = listFinal;          
        } else if (this.futureTourns !== '') {
          if (Array.isArray(data.future_tourns.future_tourns_entry)) {
            console.log("isArray");
            this.past_tourns = data.future_tourns.future_tourns_entry;
          } else {
            console.log("is not Array");
            this.past_tourns = [data.future_tourns.future_tourns_entry];
          }
          var listFinals=  this.firstArray.concat(this.past_tourns);
          this.listFinalAll = listFinals;
        }

        // if (this.daysAway > 5 || this.results_available != '' || this.ts_round_status_1 != 'S') {
        // if (this.daysAway > 5 && this.results_available != '' && this.ts_round_status_1 != 'S' || this.ts_round_status_1 != 'C') {
        this.reports = data.reports.reports_entry;
        this.reportsStart = data.reports;
        if (Array.isArray(this.reports)) {
          this.reportsArray = true;
          console.log("this.reportsArray -- women")
          console.log(this.reportsArray)
        } else {
          this.reportsArray = false;
          console.log("this.reportsArray -- women")
          console.log(this.reportsArray)
        }
        if (this.daysAway > 5 || this.reportsArray == false || this.reports.length < 3) {
          this.showReports = 'N'
          console.log('womens - 1184')
          // this.getAusSecondTournTicx() it needs to be here on LIVE
          this.getAusSecondTournTicx()
        } else {
          this.showReports = 'Y'
          this.getWPGASecondTournTicx();
          console.log('womens - 1188')
        }
        this.reportsStart = data.reports;
        if (this.reportsStart != '') {
          let arr = [];
          this.results_available = arr;
          if (Array.isArray(this.reports)) {
            this.reports.forEach((value) => {
                if (value.report_title.includes('Result')) {
                  arr.push(value.report_title);
                  // console.log(value); 
                }
            });  
          }
        }
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
    },
    OrginalWPGATMTICX:function() {
    axios
      .get(
        'https://api.aus.ocs-software.com/pgaaus/cache/wpg/' +
          "tmticx?randomadd=" +
          new Date().getTime()
      )
      .then(response => {
        this.wpgaDaysAway = response.data.days_away;
        console.log("this.wpgaDaysAway" + this.wpgaDaysAway)
      })
    }
  },
  mounted() {
    axios
      .get(
        'https://api.aus.ocs-software.com/pgaaus/cache/aus/' +
          "tmticx?multi=Y&tour=aus&tour=wpg&days=-5&daysmax=10&randomadd=" +
          new Date().getTime()
      )
      .then(response => {
        // this.OrginalWPGATMTICX();
        if (typeof response.data.aus[0][0] !== 'undefined') {
          this.allData = response.data.aus[0][0].data;
          this.AusData = response.data.aus[0][0].data;
          this.reptour = 'aus';
          this.tm_params = this.allData.tm_params.season_code;
          this.is_qualifier = this.allData.is_qualifier;
          // this.is_qualifier = this.addData.is_qualifier;
          this.tournamentName = this.allData.short_name;
          this.multi_tourns = this.allData.multi_tourns;
          this.match = this.allData.match_play;
          this.course = this.allData.code;
          this.FirstCoursecode = this.allData.code
          this.class_api = this.allData.class_api;
          // wpgacode
          const wpgData = response?.data?.wpg?.[0]?.[0]?.data;

          if (wpgData) {
            const {
              class_api,
              code,
              reports,
              days_away,
              dic_dates,
              short_name,
              is_qualifier
            } = wpgData;

            this.class_apiwpg = class_api;
            this.FirstCoursecodewpg = code;
            this.reportswpg = reports?.reports_entry ?? [];
            this.daysAwaywpg = parseInt(days_away, 10) || 0;
            this.tournDateswpg = dic_dates;
            this.tournamentNamewpg = short_name;
            this.is_qualifierwpg = is_qualifier;
          }

          this.namecourse = this.allData.course_city;
          this.timediff = this.allData.time_diff_dec;
          this.until = this.allData.days_away;
          this.codeRolex = this.allData.code;

          this.wpgaCon = [
            {
              'name': this.tournamentNamewpg,
              'code': this.FirstCoursecodewpg,
              'tour': 'wpg',
              'class_api': 'wpg'
            }
          ]

          // this.getWPGAtmticXData();     

          this.reports = this.allData.reports.reports_entry;

          console.log("this.reports")
          console.log(this.reports)
          this.reportsStart = this.allData.reports;
          if (Array.isArray(this.reports)) {
            this.reportsArray = true;
            console.log("this.reportsArray -- true")
            console.log(this.reportsArray)
          } else {
            this.reportsArray = false;
            console.log("this.reportsArray -- false")
            console.log(this.reportsArray)
          }
          this.daysAway = parseInt(this.allData.days_away);
          console.log( "this.daysAway" + this.daysAway)
          this.ts_final_result = this.allData.ts_final_result;
          if (this.daysAway > 5 ) {
            this.showReports = 'N'
          } else {
            this.showReports = 'Y'
          }
            // this.getWPGAtmticXData();

          // if (this.daysAway < this.wpgaDaysAway) {
          //   console.log('In wpga')
          //   this.showReports = 'N'
          //   this.getWPGAtmticXData();
          //   this.wpgaOnly = 'Y'
          // } else {
          //   this.showReports = 'Y'
          // }
          this.season = this.allData.tm_params.season_code;
          this.course_code = this.allData.course_code;
          this.tournDates = this.allData.dic_dates;
          this.name = this.allData.short_name;
          this.sponsorLogo = this.allData.sponsor_logo;
          this.roundPlayed = this.allData.rounds_played;
          this.scores_available = this.allData.scores_available;
          this.ts_round_status_1 = this.allData.ts_round_status_1;
          this.firstArray = [
            {
              'name': this.name,
              'code': this.course,
              'tour': 'aus',
              'class_api': 'aus'
            }
          ]
          this.reports = this.allData.reports.reports_entry;
          this.reportsStart = this.allData.reports;
          this.pastTourns = this.allData.past_tourns;
          this.futureTourns = this.allData.future_tourns;
          if (this.pastTourns != '') {
            if (Array.isArray(this.allData.past_tourns.past_tourns_entry)) {
              this.past_tourns = this.allData.past_tourns.past_tourns_entry;
            } else {
              this.past_tourns = [this.allData.past_tourns.past_tourns_entry];
            }
            var listFinal =  this.firstArray.concat(this.past_tourns, this.wpgaCon);
            this.listFinalAll = listFinal;          
          } else if (this.futureTourns !== '') {
            if (Array.isArray(this.allData.future_tourns.future_tourns_entry)) {
              this.past_tourns = this.allData.future_tourns.future_tourns_entry;
            } else {
              this.past_tourns = [this.allData.future_tourns.future_tourns_entry];
            }
            var listFinals=  this.firstArray.concat(this.past_tourns, this.wpgaCon);
            this.listFinalAll = listFinals;
          }
          if (this.reportsStart != '') {
            let arr = [];
            this.results_available = arr;
            if (Array.isArray(this.reports)) {
              this.reports.forEach((value) => {
                  if (value.report_title.includes('Result')) {
                    arr.push(value.report_title);
                    // console.log(value); 
                  }
              });  
            }
          }

          // Multi Tours 
          const ausTours = [];
          this.allAusTours = ausTours
          console.log("this.allAusTours")
          console.log(this.allAusTours)
          console.log("austour FFS")
          console.log(ausTours)
          ausTours.push({
            "Code": this.FirstCoursecode, 
            "Name" : this.tournamentName, 
            "Reports": this.reports, 
            "DaysAway": this.daysAway,
            "Dates": this.tournDates,
            "reptour": 'aus',
            "class_api": 'aus',
          })

          let wpgDatas = response?.data?.wpg?.[0]?.[0]?.data;

          if (wpgDatas) {
            const wpgaTours = [];
            this.allWpgaTours = wpgaTours
            console.log("wpgaTours FFS")
            console.log(wpgaTours)
            wpgaTours.push({
              "Code": this.FirstCoursecodewpg, 
              "Name" : this.tournamentNamewpg, 
              "Reports": this.reportswpg, 
              "DaysAway": this.daysAwaywpg,
              "Dates": this.tournDateswpg,
              "reptour": 'wpg',
              "class_api": 'wpg',
            })
          }


          this.getToursMulti();
          // End  Multi Tours 

          // this.getAllTourns();

          window.addEventListener('resize', this.myFunction);
          this.myFunction();          
          // console.clear();
          this.loading = false;
        } else if (typeof response.data.wpg[0][0] !== 'undefined') {
          this.allData = response.data.wpg[0][0].data;
          this.WpgData = response.data.wpg[0][0].data;
          console.log("this.ausData")
          console.log(this.allData)
          this.reptour = 'wpg';
          this.tm_params = this.allData.tm_params.season_code;
          this.tournamentName = this.allData.short_name;
          this.is_qualifier = this.allData.is_qualifier;
          this.multi_tourns = this.allData.multi_tourns;
          this.match = this.allData.match_play;
          this.course = this.allData.code;
          this.FirstCoursecode = this.allData.code
          this.class_api = this.allData.class_api;
          this.namecourse = this.allData.course_city;
          this.timediff = this.allData.time_diff_dec;
          this.until = this.allData.days_away;
          this.codeRolex = this.allData.code;
          // this.getWPGAtmticXData();     
          this.reports = this.allData.reports.reports_entry;
          console.log("this.reports")
          console.log(this.reports)
          this.reportsStart = this.allData.reports;
          if (Array.isArray(this.reports)) {
            this.reportsArray = true;
            console.log("this.reportsArray -- true")
            console.log(this.reportsArray)
          } else {
            this.reportsArray = false;
            console.log("this.reportsArray -- false")
            console.log(this.reportsArray)
          }
          this.daysAway = parseInt(this.allData.days_away);
          console.log( "this.daysAway" + this.daysAway)
          this.ts_final_result = this.allData.ts_final_result;
          if (this.daysAway > 5 ) {
            this.showReports = 'N'
          } else {
            this.showReports = 'Y'
          }
          // Aus
          if (typeof response.data.aus[0][0] !== 'undefined') {
            this.class_apiaus = response.data.aus[0][0].data.class_api;
            this.FirstCoursecodeaus = response.data.aus[0][0].data.code
            this.reportsaus = response.data.aus[0][0].data.reports.reports_entry;
            this.daysAwayaus= parseInt(response.data.aus[0][0].data.days_away);
            this.tournDatesaus = response.data.aus[0][0].data.dic_dates;
            this.tournamentNameaus = response.data.aus[0][0].data.short_name; 
            this.is_qualifieraus = response.data.aus[0][0].data.is_qualifier; 
            this.ausCon = [
              {
                'name': this.tournamentNameaus,
                'code': this.FirstCoursecodeaus,
              }
            ]
          }
          this.season = this.allData.tm_params.season_code;
          this.course_code = this.allData.course_code;
          this.tournDates = this.allData.dic_dates;
          this.name = this.allData.short_name;
          this.sponsorLogo = this.allData.sponsor_logo;
          this.roundPlayed = this.allData.rounds_played;
          this.scores_available = this.allData.scores_available;
          this.ts_round_status_1 = this.allData.ts_round_status_1;
          this.firstArray = [
            {
              'name': this.name,
              'code': this.course,
            }
          ]
          this.reports = this.allData.reports.reports_entry;
          this.reportsStart = this.allData.reports;
          this.pastTourns = this.allData.past_tourns;
          this.futureTourns = this.allData.future_tourns;
          if (this.pastTourns != '') {
            if (Array.isArray(this.allData.past_tourns.past_tourns_entry)) {
              this.past_tourns = this.allData.past_tourns.past_tourns_entry;
            } else {
              this.past_tourns = [this.allData.past_tourns.past_tourns_entry];
            }
            var listFinalwpg =  this.firstArray.concat(this.past_tourns, this.ausCon);
            this.listFinalAll = listFinalwpg;          
          } else if (this.futureTourns !== '') {
            if (Array.isArray(this.allData.future_tourns.future_tourns_entry)) {
              this.past_tourns = this.allData.future_tourns.future_tourns_entry;
            } else {
              this.past_tourns = [this.allData.future_tourns.future_tourns_entry];
            }
            var listFinalswpg=  this.firstArray.concat(this.past_tourns, this.ausCon);
            this.listFinalAll = listFinalswpg;
          }
          if (this.reportsStart != '') {
            let arr = [];
            this.results_available = arr;
            if (Array.isArray(this.reports)) {
              this.reports.forEach((value) => {
                  if (value.report_title.includes('Result')) {
                    arr.push(value.report_title);
                    // console.log(value); 
                  }
              });  
            }
          }

          // Multi Tours 
          const wpgaTours = [];
          this.allWpgaTours = wpgaTours;
          wpgaTours.push({
            "Code": this.FirstCoursecode, 
            "Name" : this.tournamentName, 
            "Reports": this.reports, 
            "DaysAway": this.daysAway,
            "Dates": this.tournDates,
            "reptour": 'wpg',
            "class_api": 'wpg'
          })

          let ausDatas = response?.data?.aus?.[0]?.[0]?.data;
          console.log("outAusDates")
          if (ausDatas) {
            console.log('in aus dates')
            const ausTours = [];
            this.allAusTours = ausTours
            console.log("this.allAusTours - all tours")
            console.log(this.allAusTours)
            ausTours.push({
              "Code": this.FirstCoursecodeaus, 
              "Name" : this.tournamentNameaus, 
              "Reports": this.reportsaus, 
              "DaysAway": this.daysAwayaus,
              "Dates": this.tournDatesaus,
              "reptour": 'aus',
              "class_api": 'aus'
            })
          }
          this.getToursMulti();
          // End  Multi Tours 

          window.addEventListener('resize', this.myFunction);
          this.myFunction();
          // this.getAllTourns();
          // console.clear();
          this.loading = false;
        } else {
          console.log('ALL IS EMPTY')
        }
      })
  },
  computed: {
    showRolex() {
      const params = new URLSearchParams(window.location.search);
      return params.get('rolex') !== 'N';
    },
    showTabs() {
      const params = new URLSearchParams(window.location.search);
      return params.get('leaderboard') != 'O';
    },
    filterTournaments: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '0',
      );
    },
    filterTournamentsOne: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '1',
      );
    },
    filterTournamentsTwo: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '2',
      );
    },
    filterTournamentsThree: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '3'
      );
    },
    filterTournamentsFour: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '4'
      );
    },
    
    filterReport: function() {
      if (Array.isArray(this.reports)) {
        return this.reports.filter(
          (reports_entry) =>
            reports_entry.report_title.includes("Tournament Entries") ||
            // reports_entry.report_title == 'Round 1 Draw' ||
            reports_entry.report_title.includes("Score") ||
            // reports_entry.report_title.includes("Live") ||
            reports_entry.report_title.includes("Final")
        );
      } else return this.reports; 
    },

    currentReport() {
      if (Array.isArray(this.filterReport))
        return this.filterReport[this.filterReport.length - 1].report_url;
      else return this.reports.report_url;
    },
    currentTitle() {
      if (Array.isArray(this.filterReport))
        return this.filterReport[this.filterReport.length - 1].report_title;
      else return this.reports.report_title;
    },
    reportTitle: function(url) {
      if (this.NextTournCode[0] == 'aus') {
        console.log('AUS YESSS')
        this.tourCode == 'aus'
        if (this.currentReport.indexOf("tmentry") !== -1) {
          url =
            this.config.VUE_APP_TIC_BASE +
            'aus' +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-entryw-entries.json?Ausrandomadd=" +
            new Date().getTime();
        } else {
          if (this.currentReport.indexOf("tmscore") !== -1) {
            var subRep3 = this.currentReport.lastIndexOf("params=") + 7;
            var indNext3 = this.currentReport.indexOf("~", subRep3);
            var repParams1 = this.currentReport.substr(
              subRep3,
              indNext3 - subRep3
            );
            if (repParams1 && repParams1.indexOf(".cgi") < 0) {
              url =
                this.config.VUE_APP_TIC_BASE +
                'aus' +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                // this.course +
                this.course +
                "-scores-" +
                repParams1 +
                ".json" +
                "?randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/" + "dev" + "/cache/" + "dev" + "/" + "215S" + "/" + "215S" + "-" + "AUS7" + "-scores-" + $scope.repParams + ".json"+"?randomadd=1603894106415";
            } else {
              url =
                this.config.VUE_APP_TIC_BASE +
                'aus'  +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
            }
          } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
            {
              url =
                this.config.VUE_APP_TIC_BASE +
                'aus'  +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
            }
          } else if (this.currentReport.indexOf("tmdraw") !== -1) {
            var subRep6 = this.currentReport.lastIndexOf("round=") + 6;
            var indNext6 = this.currentReport.indexOf("~", subRep6);
            var drawRnd6 = this.currentReport.substr(subRep6, indNext6 - subRep6);
            url =
              this.config.VUE_APP_TIC_BASE +
              'aus'  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-draw-R" +
              drawRnd6 +
              "-draw.json" +
              "?randomadd=" +
              new Date().getTime();
          } else if (this.currentReport.indexOf("tmresult") !== -1) {
            var subRep5 = this.currentReport.lastIndexOf("result=") + 7;
            var indNext5 = this.currentReport.indexOf("~", subRep5);
            var resNum5 = this.currentReport.substr(subRep5, indNext5 - subRep5);
            console.log("resNum === ");
            console.log(resNum5);
            url =
              this.config.VUE_APP_TIC_BASE +
              'aus'  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-" +
              resNum5 +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              this.config.VUE_APP_TIC_BASE +
              'aus'  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-PF.json" +
              "?randomadd=" +
              new Date().getTime();
          }
        }
        return url;
      } else if(this.NextTournCode[0] == 'wpg') {
        console.log('WPG YESSS')
        this.tourCode == 'wpg'
        if (this.currentReport.indexOf("tmentry") !== -1) {
          url =
            this.config.VUE_APP_TIC_BASE +
            'wpg' +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-entryw-entries.json?WPGrandomadd=" +
            new Date().getTime();
        } else {
          if (this.currentReport.indexOf("tmscore") !== -1) {
            var subRep8 = this.currentReport.lastIndexOf("params=") + 7;
            var indNext8 = this.currentReport.indexOf("~", subRep8);
            var repParams2 = this.currentReport.substr(
              subRep8,
              indNext8 - subRep8
            );
            if (repParams2 && repParams2.indexOf(".cgi") < 0) {
              url =
                this.config.VUE_APP_TIC_BASE +
                'wpg' +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                // this.course +
                this.course +
                "-scores-" +
                repParams2 +
                ".json" +
                "?randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/" + "dev" + "/cache/" + "dev" + "/" + "215S" + "/" + "215S" + "-" + "AUS7" + "-scores-" + $scope.repParams + ".json"+"?randomadd=1603894106415";
            } else {
              url =
                this.config.VUE_APP_TIC_BASE +
                'wpg'  +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
            }
          } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
            {
              url =
                this.config.VUE_APP_TIC_BASE +
                'wpg'  +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
            }
          } else if (this.currentReport.indexOf("tmdraw") !== -1) {
            var subRep9 = this.currentReport.lastIndexOf("round=") + 6;
            var indNext9 = this.currentReport.indexOf("~", subRep9);
            var drawRnd9 = this.currentReport.substr(subRep9, indNext9 - subRep9);
            url =
              this.config.VUE_APP_TIC_BASE +
              'wpg'  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-draw-R" +
              drawRnd9 +
              "-draw.json" +
              "?randomadd=" +
              new Date().getTime();
          } else if (this.currentReport.indexOf("tmresult") !== -1) {
            var subRep10 = this.currentReport.lastIndexOf("result=") + 7;
            var indNext10 = this.currentReport.indexOf("~", subRep10);
            var resNum10 = this.currentReport.substr(subRep10, indNext10 - subRep10);
            console.log("resNum === ");
            console.log(resNum10);
            url =
              this.config.VUE_APP_TIC_BASE +
              'wpg'  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-" +
              resNum10 +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              this.config.VUE_APP_TIC_BASE +
              'wpg'  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-PF.json" +
              "?randomadd=" +
              new Date().getTime();
          }
        }
        return url;
      } else {
        this.tourCode == 'aus'
        if (this.currentReport.indexOf("tmentry") !== -1) {
          url =
            this.config.VUE_APP_TIC_BASE +
            this.reptour +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-entryw-entries.json?randomaddAll=" +
            new Date().getTime();
        } else {
          if (this.currentReport.indexOf("tmscore") !== -1) {
            var subRep11 = this.currentReport.lastIndexOf("params=") + 7;
            var indNext11 = this.currentReport.indexOf("~", subRep11);
            var repParams3 = this.currentReport.substr(
              subRep11,
              indNext11 - subRep11
            );
            if (repParams3 && repParams3.indexOf(".cgi") < 0) {
              url =
                this.config.VUE_APP_TIC_BASE +
                this.reptour +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                // this.course +
                this.course +
                "-scores-" +
                repParams3 +
                ".json" +
                "?randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/" + "dev" + "/cache/" + "dev" + "/" + "215S" + "/" + "215S" + "-" + "AUS7" + "-scores-" + $scope.repParams + ".json"+"?randomadd=1603894106415";
            } else {
              url =
                this.config.VUE_APP_TIC_BASE +
                this.reptour  +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
            }
          } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
            {
              url =
                this.config.VUE_APP_TIC_BASE +
                this.reptour  +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
            }
          } else if (this.currentReport.indexOf("tmdraw") !== -1) {
            var subRep12 = this.currentReport.lastIndexOf("round=") + 6;
            var indNext12 = this.currentReport.indexOf("~", subRep12);
            var drawRnd12 = this.currentReport.substr(subRep12, indNext12 - subRep12);
            url =
              this.config.VUE_APP_TIC_BASE +
              this.reptour  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-draw-R" +
              drawRnd12 +
              "-draw.json" +
              "?randomadd=" +
              new Date().getTime();
          } else if (this.currentReport.indexOf("tmresult") !== -1) {
            var subRep13 = this.currentReport.lastIndexOf("result=") + 7;
            var indNext13 = this.currentReport.indexOf("~", subRep13);
            var resNum13 = this.currentReport.substr(subRep13, indNext13 - subRep13);
            console.log("resNum === ");
            console.log(resNum13);
            url =
              this.config.VUE_APP_TIC_BASE +
              this.reptour  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-" +
              resNum13 +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              this.config.VUE_APP_TIC_BASE +
              this.reptour  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-PF.json" +
              "?randomadd=" +
              new Date().getTime();
          }
        }
      }
      return url;
    },
  },
  //  metaInfo() {
  //    //Injects Meta and Title to Head
  //    return {
  //      title: this.title.content,
  //      meta: [
  //        {
  //          name: this.description.name,
  //          content: this.description.content
  //        }
  //      ]
  //    };
  //  },
  created() {
    localStorage.clear();
    // this.myFunction();
    // window.addEventListener('resize', this.myFunction);
    setInterval(
      console.log('In Interval 270'),
      this.updateSize, 12000,
      console.log('In Interval 272')
    );
    // this.getAllTourns();
    this.reportListText();
    // this.getReports(current);
  },
};
</script>
<style scoped>
::v-deep .dropdown.b-dropdown.mobileDropdown.btn-group {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  vertical-align: middle;
  border: 0px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
}
::v-deep .dropdown.b-dropdown.mobileDropdown.btn-group > button {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
  text-align: left;
}
::v-deep .dropdown-toggle::after {
  text-align: right;
  float: right;
  position: relative;
  top: 10px;
}
::v-deep ul.dropdown-menu.show {
  width: 100%;
}
::v-deep .dropdown-item {
  color: #000!important;
}
option.showNone {
  display: none;
}
.suspendBkColor {
  background-color: blue!important;
}
.suspend {
  position: absolute;
  bottom: 0!important;
  background: red!important;
  width: 100%!important;
  text-align: center;
  color: #fff;
  padding-left: 20px;
  padding-right: 23px;
}
::v-deep option.opt-arrow.showNone {
  display: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
}
.RolexSection {
  margin-top: 6px;
}
.colClass {
  padding: 0!important;
}
.LiveScoreMessage {
  position: absolute;
  /* bottom: 66px; */
  bottom: 0px;
  background: red;
  width: 93%;
  text-align: center;
  color: #fff;
  /* white-space: nowrap; */
  /* overflow: hidden; */
  padding-left: 20px;
  padding-right: 23px;
}
.mobStyleWid {
  width: 100%!important;
  bottom: 2px!important;
}
.LiveScoreMessage > p {
  margin-bottom: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
.TournDrop {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
}
::v-deep li.nav-item.tabsStyle.tabWidth {
  width: 50%;
}
::v-deep .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: transparent;
}
::v-deep .tabone {
  width: 27%;
}
::v-deep .tabtwo {
  width: 40%;
}
::v-deep .tabthree {
  width: 33%;
}
.homeHeight {
  /* height: 669px; */
  /* height: 605px; */
  height: 589px;
}
.HomehomeReport-list {
  border: 1px solid #E6E6E6;
}
::v-deep li.nav-item.tabsStyle {
  /* width: 33%; */
}
::v-deep li.nav-item.tabsStyle > a{
  /* padding-left: 13px!important;
  padding-right: 10px!important; */
}
::v-deep .nav-tabs .nav-link:hover {
  cursor: default;
  background-color: #dfe1e6;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 13px;
  color: #00433e !important;
  padding-left: 18px;
  padding-right: 20px;
  text-align: center;
}
::v-deep .nav-tabs .nav-link.active {
  cursor: default;
  background-color: #fff;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  color: #34caa9 !important;
  padding-left: 18px;
  padding-right: 20px;
  border-bottom: 0px solid #dee2e6;
  padding-top: 14px;
  padding-bottom: 35px;
  border: none!important;
}
::v-deep .nav-tabs .nav-link {
  cursor: default;
  background-color: #E6E6E6;
  color: #B8B8B8 !important;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  padding-left: 18px;
  padding-right: 20px;
  border-bottom: 0px solid #dee2e6;
  text-align: center;
  padding-top: 14px;
  padding-bottom: 35px;
  border: none!important;
}
::v-deep .nav-tabs {
    border-bottom: 0px solid #dee2e6;
}
/* ::v-deep .tabWhite { 
  padding-top: 0em;
  height: 581px;
} */
.home {
  background-color: #fff;
}
.title {
  font-weight: 500;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  color: #000;
  font-size: 23pt;
  margin-top: 1em;
  line-height: 1.1;
  /* letter-spacing: 2px; */
}

.ad {
  padding: 15px 0; 
}

.bottomAdBanner {
  width: 100%;
}
.sections {
  padding: 30px 0;
}
.box {
  display: block;
  top: 0px;
  border-radius: 4px;
  position: relative;
  text-decoration: none;
  z-index: 0;
  overflow: hidden;
}

.box:hover {
  transition: all 0.3s ease;
  box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
  top: -4px;
  background-color: white;
}
@media only screen and (max-height: 1024px) {
  .homeReport-list {
    /* height: auto !important; */
  }
}

@media only screen and (max-height: 990px) {
  ::v-deep option.opt-arrow.showNone {
    display: block;
    -webkit-appearance: block;
    -moz-appearance: block;
    -o-appearance: block;
    appearance: block;
  }
}
@media only screen and (min-height: 501px) {
  .homeContainer.container {
    padding-left: 0px!important;
    padding-right: 0px!important;
  }
  ::v-deep option.opt-arrow.showNone {
    display: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
  }
}
@media only screen and (max-height: 500px) {
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px!important;
  }
}
@media only screen and (max-height: 430px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    color: #34caa9 !important;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    padding-top: 15px;
    padding-bottom: 35px;
    border: none!important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    padding-top: 15px;
    padding-bottom: 35px;
    border: none!important;
  }
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px!important;
  }
}
.mobWidgetPad {
  height: 476px!important;
}


@media only screen and (max-width: 480px) {
  .bottomAdBanner{
    padding: 15px 0;
  }
  .hero-plus__html-content iframe {
    width: 94%!important;
    height: 980px!important;
  }
}

@media only screen and (max-width: 419px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    color: #34caa9 !important;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
  }
}

@media only screen and (max-width: 400px) {
  ::v-deep option.hideMobNow {
    display: none!important;
  }
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #34caa9 !important;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link:hover {
    cursor: default;
    background-color: #dfe1e6;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #00433e !important;
    padding-left: 18px;
    padding-right: 20px;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
}
@media only screen and (max-width: 321px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #34caa9 !important;
    padding-left: 10px;
    padding-right: 15px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    padding-left: 10px;
    padding-right: 15px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link:hover {
    cursor: default;
    background-color: #dfe1e6;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #00433e !important;
    padding-left: 10px;
    padding-right: 15px;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
}
@media only screen and (max-width: 375px) {
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px;
  }
}
</style>
